<script setup lang="ts">
import { useModalStore } from '@/stores/modalStore.ts';

const modal = useModalStore()
</script>

<template>
  <v-dialog v-model="modal.isOpen">
    <component
      :is="modal.component"
      v-bind="modal.props"
      @close-modal="modal.closeModal"
      class="mx-auto"
    />
  </v-dialog>
</template>
